<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <takeaway_general_tab :location="location"></takeaway_general_tab>
        </template>
    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import takeaway_general_tab from "./tabs/takeaway_general_tab";
import Location_super_categs from "../../base/location_modal/tabs/location_super_categs";

export default {
    name: "takeaway_location_modal",
    components : {
        takeaway_general_tab,
        base_location_modal,
    },
    data () {
        return {
            tabs_add: []
        }
    }
}
</script>

<style scoped>

</style>
